/**
 * Статус клиента в раскрытой карточке «Нового года» (04.11.2026, владелец): «Новая» (по умолчанию), «В работе», «Отказ» —
 * ставит ДК (PUT /api/ny/clients/:ref/status); «Бронь» и «Предоплата» ставятся сами по броням и ручной статус перебивают.
 * «Отказ», пока статус стоит по брони, не даём (сервер тоже отвечает 409 с текстом почему). Нет карточки клиента (без телефона
 * или номер-заглушка) — переключатель недоступен: статус не к кому привязать. Новая заявка после «В работе» / «Отказ»
 * показывает «Новую» с подсказкой, какой статус был (reopenHint); нажать — записать, ответ на заявку.
 */
import { useState } from "react";
import { fmtStamp, type NyCard, type NyManual } from "./nyModel";
import { autoHint, autoStatus, pickChanges, reopenHint, NY_MANUAL_OPTS, NY_STATUS } from "./nyStatus";
import { errText, nySetStatus } from "./useNy";
import ny from "./dcNy.module.css";

export function NyStatusBar({ card, onChanged, onToast }: { card: NyCard; onChanged: () => void; onToast: (m: string) => void }) {
  const [busy, setBusy] = useState<NyManual | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const ref = card.id;
  const auto = autoStatus(card);
  const hint = autoHint(card);
  const reopen = reopenHint(card);
  const set = async (s: NyManual) => {
    if (ref == null || busy || !pickChanges(card, s)) return;
    setBusy(s); setErr(null);
    try { await nySetStatus(ref, s); onToast(`Статус: ${NY_STATUS[s]}${auto ? ` (на экране — «${NY_STATUS[card.status]}» по брони)` : ""}`); onChanged(); }
    catch (e) { setErr(errText(e, "Не удалось поменять статус")); }
    finally { setBusy(null); }
  };
  return (
    <div className={ny.stBar}>
      <div className={ny.stRow} role="radiogroup" aria-label="Статус клиента">
        <span className={ny.stLbl}>Статус</span>
        {NY_MANUAL_OPTS.map((o) => {
          const on = card.manual_status === o.key;
          const off = ref == null || (o.key === "refused" && auto);
          return (
            <button key={o.key} type="button" role="radio" aria-checked={on} disabled={off || !!busy}
              className={`${ny.stOpt} ${on ? (auto ? ny.stOptDim : ny.stOptOn) : ""}`}
              title={o.key === "refused" && auto ? "Есть бронь — сначала отмените её в модалке брони" : undefined}
              onClick={() => { void set(o.key); }}>{busy === o.key ? "…" : o.label}</button>
          );
        })}
      </div>
      {hint ? <div className={ny.hint}>{hint}</div> : null}
      {ref == null ? <div className={ny.hint}>Нет телефона клиента (или это номер-заглушка) — статус привязать не к кому.</div> : null}
      {reopen ? <div className={ny.hint}>{reopen}</div> : null}
      {card.status_by && !auto && !reopen ? <div className={ny.hint}>Поставил(а): {card.status_by}{card.status_at ? `, ${fmtStamp(card.status_at)}` : ""}</div> : null}
      {err ? <div className={ny.err} role="alert">{err}</div> : null}
    </div>
  );
}
